module.exports = __webpack_public_path__ + "static/kobylarz-logo-f7dd3d3222e2d1473a9ea54dc9fc9c69.svg";